import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import HeaderLayout from '@/components/common/CustomLayout/HeaderLayout';

import LeftSection from './LeftSection';
import RightSection from './RightSection';

import { useAppDispatch } from '@/store';
import { getClubById, updateClub } from '@/store/clubs/action';
import Header from './Header';

const ClubDetail = () => {
	const { clubId } = useParams();

	const [club, setClub] = useState<Club | null>(null);
	const form = useForm();
	const dispatch = useAppDispatch();
	
	const navigate = useNavigate();

	useEffect(() => {
		if (clubId) {
			const setClubDetail = (clubVal: Club) => {
				form.setValue('clubStatus', clubVal.status);
				setClub(clubVal);
			};

			dispatch(getClubById({ clubId, success: setClubDetail }));
		}
	}, [clubId]);

	const handleClick = () => {
		const clubRequest: ClubRequest = {
			id: clubId,
			status: form.watch('clubStatus'),
		};

		if (clubId) {
			dispatch(updateClub(clubRequest));
		} 
		navigate('/dashboard/customer/clubs');
	};
	return (
		<FormProvider {...form}>
			<HeaderLayout
				title="Edit Club"
				rightComponent={Header({ handleClick, form })}
			>
				<div className="flex justify-between">
					<div className="flex-[3_3_0%]">
						{ club != null && 
							<LeftSection name={club.name} desc={club.description} schedules={club.schedules}/> 
						}
					</div>
					<div className="flex-[1_1_0%] card ml-6">
						{ club != null && 
							<RightSection logoUrl={club.logo_url} coverUrl={club.cover_url} photoUrls={club.photo_urls} adminName={club.admin.name} adminPhone={club.admin.phone_number}/>
						}
					</div>
				</div>
			</HeaderLayout>
		</FormProvider>
	);
};

export default ClubDetail;
